import { ROUTES } from '../../../constants/routes';
import Reveal from '../../common/Reveal';
import HomeCarouselRow from '../shared/HomeCarouselRow';
import ViewAllButton from '../shared/ViewAllButton';
import FreeCourseCard from './FreeCourseCard';

const HOME_PREVIEW_COUNT = 4;

function FreeCoursesSection({ courses, loading }) {
  const list = (courses || []).slice(0, HOME_PREVIEW_COUNT);
  const hasCourses = list.length > 0;

  if (!loading && !hasCourses) {
    return null;
  }

  return (
    <section className="bg-gradient-to-b from-[#eef3fc] via-[#f3f0fb] to-[#f8f5ff] px-4 py-8 sm:px-6 sm:py-10 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <Reveal variant="up">
          <h2 className="text-center text-2xl font-bold text-[#1B1B1B] sm:text-3xl lg:text-4xl xl:text-[40px]">
            Free Courses
          </h2>
        </Reveal>

        <div className="mt-10">
          {loading && !hasCourses ? (
            <div className="flex justify-center gap-5 overflow-hidden">
              {[1, 2, 3, 4].map((n) => (
                <div
                  key={n}
                  className="h-[420px] w-[288px] shrink-0 animate-pulse rounded-2xl bg-white/80"
                />
              ))}
            </div>
          ) : (
            <HomeCarouselRow
              items={list}
              layout="cards"
              renderItem={(course) => <FreeCourseCard course={course} />}
            />
          )}
        </div>

        {hasCourses && (
          <Reveal variant="up" delay={120}>
            <div className="mt-10 flex justify-center sm:mt-12">
              <ViewAllButton label="View All Courses" variant="light" to={ROUTES.FREE_COURSES} />
            </div>
          </Reveal>
        )}
      </div>
    </section>
  );
}

export default FreeCoursesSection;
